import React from "react";

import { useTranslation } from "react-i18next";

import { Select } from "antd";

import { IntervalType } from "../../../../store/widgets/types";
import styles from "../../conversions/styles.module.scss";

export interface IntervalSelectorProps {
  value: IntervalType;
  onSelect: (interval: IntervalType) => void;
}

export const IntervalSelector: React.FC<IntervalSelectorProps> = (props) => {
  const { value, onSelect } = props;
  const { t } = useTranslation("widget");

  return (
    <Select
      value={value}
      bordered={false}
      onSelect={onSelect}
      className={styles.selector}
      dropdownMatchSelectWidth={false}
      showArrow={true}
      suffixIcon={<i className={"ant-menu-submenu-arrow"} />}
    >
      <Select.Option value="today">{t("intervals.today")}</Select.Option>
      <Select.Option value="yesterday">{t("intervals.yesterday")}</Select.Option>
      <Select.Option value="last3d">{t("intervals.last3d")}</Select.Option>
    </Select>
  );
};
